import { render, staticRenderFns } from "./TimerPrice.vue?vue&type=template&id=758972ed&"
import script from "./TimerPrice.vue?vue&type=script&lang=js&"
export * from "./TimerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports